import React from 'react';
import { Route, useLocation, useParams } from 'react-router-dom';
import * as ROUTES from '../constants/routes';
import { initiativeTypes } from '../constants';

import ChangeInsightsStudioShow from '../pages/change-insights/studio/show';
import ChangeInsightsStudioSettings from '../pages/change-insights/studio/settings';
import ChangeInsightsStudioRespondentAnswers from '../pages/change-insights/studio/respondent-answers';
import ChangeInsightsStudioPreview from '../pages/change-insights/studio/preview';
import ChangeInsightsNew from '../pages/change-insights/new';
import ChangeInsightsEdit from '../pages/change-insights/edit';
import ChangeInsightsAnalysisShow from '../pages/change-insights/analysis/show';

// Wrapper to inject initiativeType from URL path
const createInitiativeWrapper = (BaseComponent) => {
  return () => {
    const location = useLocation();
    const params = useParams();

    const pathSegments = location.pathname.split('/').filter(Boolean);
    const initiativeType = pathSegments.find((segment) =>
      initiativeTypes.includes(segment)
    );

    return <BaseComponent {...params} initiativeType={initiativeType} />;
  };
};

const ChangeInsightsStudio = createInitiativeWrapper(ChangeInsightsStudioShow);
const ChangeInsightsStudioSettingsWrapped = createInitiativeWrapper(
  ChangeInsightsStudioSettings
);
const ChangeInsightsStudioRespondentAnswersWrapped = createInitiativeWrapper(
  ChangeInsightsStudioRespondentAnswers
);
const ChangeInsightsNewWrapped = createInitiativeWrapper(ChangeInsightsNew);
const ChangeInsightsEditWrapped = createInitiativeWrapper(ChangeInsightsEdit);
const ChangeInsightsAnalysis = createInitiativeWrapper(
  ChangeInsightsAnalysisShow
);

export const changeInsightsRoutes = () => {
  return (
    <>
      {/* Generate routes for all initiative types */}
      {initiativeTypes.map((type) => (
        <React.Fragment key={type}>
          <Route
            path={ROUTES.CHANGE_INSIGHTS_STUDIO_SHOW.replace(
              ':initiativeType',
              type
            )}
            element={<ChangeInsightsStudio />}
          />
          <Route
            path={ROUTES.CHANGE_INSIGHTS_STUDIO_SETTINGS.replace(
              ':initiativeType',
              type
            )}
            element={<ChangeInsightsStudioSettingsWrapped />}
          />
          <Route
            path={ROUTES.CHANGE_INSIGHTS_STUDIO_RESPONDENT_ANSWERS.replace(
              ':initiativeType',
              type
            )}
            element={<ChangeInsightsStudioRespondentAnswersWrapped />}
          />
          <Route
            path={ROUTES.CHANGE_INSIGHTS_NEW.replace(':initiativeType', type)}
            element={<ChangeInsightsNewWrapped />}
          />
          <Route
            path={ROUTES.CHANGE_INSIGHTS_EDIT.replace(':initiativeType', type)}
            element={<ChangeInsightsEditWrapped />}
          />
          <Route
            path={ROUTES.CHANGE_INSIGHTS_ANALYSIS_SHOW.replace(
              ':initiativeType',
              type
            )}
            element={<ChangeInsightsAnalysis />}
          />
        </React.Fragment>
      ))}

      {/* Organization-level Change Insights Studio Preview */}
      <Route
        path={ROUTES.CHANGE_INSIGHTS_STUDIO_PREVIEW}
        element={<ChangeInsightsStudioPreview />}
      />
    </>
  );
};
